import React, { useEffect, useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import { useLocation } from "react-router-dom";
import HeadingComponent from "components/headingComponent";
import ViewDataComponent from "components/viewData";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";


function TeachersDetailView() {
  const [jobInfo, setJobInfo] = useState([]);
  const [personalInfoView, setPersonalInfoView] = useState([]);
  const [personalInfoViews, setPersonalInfoViews] = useState([]);

  const [otherInfoView, setOtherInfoView] = useState([]);
  const [bankInfoView, setBankInfoView] = useState([]);

  const location = useLocation();

   // MARK: Use effect
  useEffect(() => {

    if (location.state) {
      setJobInfo([
        {
          label: "Joining Date:",
          data: joiningDateTimestamp(),
          class: "ms-0", isShown: false
        },
        {
          label: "Salary:",
          data: location.state.salary_num,
          class: "ms-0", isShown: false
        },
        {
          label: "Department:",
          data: location.state.department,
          class: "table__column__capital ms-0", isShown: false
        },
        {
          label: "Designation:",
          data: location.state.designation,
          class: "table__column__capital ms-0", isShown: false
        },
      ]);

      setPersonalInfoView([
        { label: "Name:", data: location.state.name ? location.state.name : "null", class: "table__column__capital ms-0", isShown: false },
        { label: "Email:", data: location.state.email ? location.state.email : "Null", class: "ms-0", isShown: false },
        {
          label: "Date of Birth:",
          data: birthDateTimestamp(),
          class: "ms-0", isShown: false
        },
        {
          label: "Teacher ID:",
          data: location.state.id,
          class: "ms-0",isShown: true
        },
      
      ]);

      setPersonalInfoViews([
        { label: "Marital Status:", data: location.state.selected_marital_status, class: "table__column__capital ms-0", isShown: false },
        {
          label: "Contact number:",
          data: location.state.contact_no,
          class: "ms-0", isShown: false
        },
        {
          label: "Whatsapp number:",
          data: location.state.whatsapp_no ? location.state.whatsapp_no : "Null",isShown: false,
          class: "ms-0"
        },
        {
          label: "PAN/Aadhaar Number:",
          data: location.state.pan_number ? location.state.pan_number : "Null",
          class: "ms-0",isShown: false
        },
      ]);

      setOtherInfoView([
        {
          label: "Father/Husband Name:",
          data: location.state.father_husband_name ? location.state.father_husband_name : "null",
          class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "Father/Husband Contact No.:",
          data: location.state.father_husband_no ? location.state.father_husband_no : "Null",
          class: "ms-0",isShown: false
        },
        {
          label: "Address:",
          data: location.state.address ? location.state.address : "null",
          class: "table__column__capital ms-0",isShown: false
        },
      ]);

      setBankInfoView([
        {
          label: "Account Number:",
          data: location.state.account_no ? location.state.account_no : "null",
          class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "Bank Name:",
          data: location.state.bank_name ? location.state.bank_name : "Null",
          class: "table__column__capital ms-0",isShown: false
        },
        {
          label: "IFSC Code:",
          data: location.state.bank_code ? location.state.bank_code : "null",
          class: "ms-0",isShown: false
        },
        {
          label: "Account Holder Name:",
          data: location.state.account_holder_name ? location.state.account_holder_name : "null",
          class: "table__column__capital ms-0",isShown: false
        },
      ]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

   useLayoutEffect(() => {
    document.title = CommonHeadings.teacherView;
  }, []);

  // MARK: date format
  function joiningDateTimestamp() {
    return (
      <Moment format={Dateformat.DDMMYYYY}>
        {location.state.joining_date}
      </Moment>
    );
  }

  function birthDateTimestamp() {
    return location.state.dob ? <Moment format={Dateformat.DDMMYYYY}>{location.state.dob}</Moment> : "Null";
  }


  return (
    <div className="modules__main__div">
      <div className="col-12">

        <div className="card card-column mt-5">
          {personalInfoView.length > 0 && (
            <HeadingComponent
              headingName="Basic Info"
              classname="mb-3 mt-5 text-center"
            />
          )}
          <div className="row">
          <div  className="col-6">
          {personalInfoView.length > 0 &&
            personalInfoView.map((data) => (
              <ViewDataComponent
                key={data.label}
                label={data.label}
                data={data.data}
                isShown={data.isShown}
                class={data.class}
              />
            ))}
            </div>
            
          <div  className="col-6">
          {personalInfoViews.length > 0 &&
            personalInfoViews.map((data) => (
              <ViewDataComponent
                key={data.label}
                label={data.label}
                data={data.data}
                isShown={data.isShown}
                class={data.class}
              />
            ))}
            </div>
            </div>
        </div>

        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-3 mt-5">
        <div className="col">
            <div className="card card-column ">
              {bankInfoView.length > 0 && (
                <HeadingComponent
                  headingName="Bank Info"
                  classname="mb-3 mt-5 text-center"
                />
              )}
              {bankInfoView.length > 0 &&
                bankInfoView.map((data) => (
                  <ViewDataComponent
                    key={data.label}
                    label={data.label}
                    data={data.data}
                    isShown={data.isShown}
                    class={data.class}
                  />
                ))}
            </div>
          </div>

          <div className="col">
            <div className="card card-column " style={{height: "21.55rem"}}>
              {jobInfo.length > 0 && (
                <HeadingComponent
                  headingName="Job Info"
                  classname="mb-3 mt-5 text-center"
                />
              )}
              {jobInfo.length > 0 &&
                jobInfo.map((data) => (
                  <ViewDataComponent
                    key={data.label}
                    label={data.label}
                    data={data.data}
                    isShown={data.isShown}
                    class={data.class}
                  />
                ))}
            </div>
          </div>

          <div className="col">
            <div className="card card-column " style={{height: "21.55rem"}}>

              {otherInfoView.length > 0 && (
                <HeadingComponent
                  headingName="Other Info"
                  classname="mb-3 mt-5 text-center"
                />
              )}
              {otherInfoView.length > 0 &&
                otherInfoView.map((data) => (
                  <ViewDataComponent
                    key={data.label}
                    label={data.label}
                    data={data.data}
                    isShown={data.isShown}
                    class={data.class}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeachersDetailView;
